import GenericModal from "components/Modal";
import DeleteConfirmationModal from "components/Modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import AddProduct from "./AddProducr";
import Product from "./Product";

import httpClient from "services/network/httpClient";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import EditProducts from "./EditProduct";
import { showToast } from "components/Toaster";
import React from "react";

interface ProductActionCellProps {
  row: object;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
}

const ProductActionCell: React.FC<ProductActionCellProps> = ({ row, onEdit, onDelete }) => (
  <div className="flex space-x-2">
    <button
      type="button"
      onClick={() => onEdit(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Edit product"
    >
      <FontAwesomeIcon icon={faEdit} />
    </button>
    <button
      type="button"
      onClick={() => onDelete(row)}
      className="px-2 py-2 rounded-lg cursor-pointer"
      aria-label="Delete product"
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  </div>
);

const ProductList = () => {
  const [isAddingProd, setIsAddingProd] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [isView, setIsView] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();

  const getData = () => {
    setLoading(true);
    console.log("Inside Product get data function");
    httpClient
      .get("product/all?page=1&size=2000")
      .then((res: any) => {
        console.log("Inside Product get data response data");
        setData(res.value.contents);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = (row: any) => {
    setIsEdit(true);
    setEditData(row);
  };



  const handleDelete = (row: any) => {
    console.log(row);
    setDeleteData(row);
    setIsDelete(true);
  };

  const tableData = [
    {
      key: "productCode",
      label: "product Code",
      bold: true,
    },
    { key: "productName", label: `Product Name`, bold: true },
    {
      key: "actions",
      label: "Actions",
      excludeExport: true,
      actions: (row: object) => (
        <ProductActionCell row={row} onEdit={handleEdit} onDelete={handleDelete} />
      ),
    },
  ];
  const handleAdd = () => {
    console.log("Handle Add");
    setIsAddingProd(true);
  };

  const deleteFunction = () => {
    httpClient
      .delete(`product/delete/${deleteData.id}?isDeleted=true`)
      .then((res) => {
        console.info("you are try to deleting");
        console.log(res);
        if (res.success === true) {
          getData();
          showToast(`${deleteData.productName} Product deleted successfully`, "success");
        } else {
          showToast(`${res.error.message}`, "error");
        }
      })
      .catch((error: any) => {
        console.info("Inside Error");
        console.log(error);
        showToast("something went wrong");
      })
      .finally(() => {
        console.info("you are in finally block");
        setIsDelete(false);
        getData();
      });
  };
  return (
    <div>
      <div className="">
        <div className="overflow-x-auto">
          <Product
            data={data}
            columns={tableData}
            loading={loading}
            onAdd={handleAdd}
          ></Product>
        </div>
      </div>
      {isAddingProd && (
        <GenericModal
          isOpen={isAddingProd}
          onClose={() => setIsAddingProd(false)}
          header="Add Product "
          customWidth="md:w-96"
        >
          <AddProduct
            onClose={() => setIsAddingProd(false)}
            getData={getData}
          ></AddProduct>
        </GenericModal>
      )}
      {isEdit && (
        <GenericModal
          isOpen={isEdit}
          onClose={() => setIsEdit(false)}
          header="Edit Product Details"
          customWidth="md:w-96"
        >
          <EditProducts
            updatedData={editData}
            onClose={() => setIsEdit(false)}
            getData={getData}
          ></EditProducts>
        </GenericModal>
      )}
      {isView && (
        <GenericModal isOpen={isView} onClose={() => setIsView(false)}>
          <button></button>
        </GenericModal>
      )}
      {isDelete && (
        <DeleteConfirmationModal
          isOpen={isDelete}
          onClose={() => setIsDelete(false)}
          onConfirm={deleteFunction}
          entityName="Product"
          title="Delete Product"
        />
      )}
    </div>
  );
};
export default ProductList;
